import ApplePayMethod from './ApplePayMethod';
import ApplePayIcon from 'dibs-icons/exports/legacy/ApplePay';
import styles from './styles/CheckoutApplePayView.scss';

const CheckoutApplePayView = () => (
    <div className={styles.applePayViewContainer}>
        <div className={styles.applePayIconContainer}>
            <ApplePayIcon className={styles.applePayIcon} />
        </div>
        <ApplePayMethod />
    </div>
);

export default CheckoutApplePayView;
